import React, {useContext, useEffect, useState} from 'react'
import t from 'helpers/I18n'

import PropTypes from 'prop-types'
import {AppDataContext} from 'contexts/app-data'

import BaseParagraph from "../../base-components/base-paragraph";
import { useHistory } from 'react-router-dom';
import StepsLoader from "../steps-loader";
import InputField from "../../base-components/base-input";
import getStep from '../../../helpers/getStep';


const BelgianResidenceStep = ({_step_service, step_ID, step_URL, next_step, setDataToContext, getDataFromContext}) => {

    const history = useHistory();
    //const handleClick = () => history.push('/legal-residence');
    const data = getDataFromContext(step_ID)
    const {state, dispatch} = useContext(AppDataContext)
    const [inputData, setInputData] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [nextTick, setNextTick] = useState(false)
    const [savedData, setSavedData] = useState({})


    const getInputValue = (name, value) => {
        setInputData({
            ...inputData,
            [name] : value
        })
        // inputData.belgianResident === 1 && setDataToContext(step_ID, step_URL, name, value)
    }

    const action = () => {
        _step_service({step_ID, setIsLoading, next_step})
    }

    const endFlow = () => {
        dispatch({
            type: 'SET_END_FLOW_MESSAGE',
            end_flow:{
                title:t('exit_messages.impossible_body_title'),
                description: t('exit_messages.belgian_residency'),
                exit_statut: 1
            }
        })

        // history.push('/steps/end-flow')
    }

    useEffect(() => {
        if (inputData["belgium_resident"] === 1) {
            setDataToContext(step_ID, step_URL, "belgium_resident", 1)
            setNextTick(true)
        }
        if (inputData["belgium_resident"] === 0) {
            setDataToContext(step_ID, step_URL, "belgium_resident", 0)
            setNextTick(true)

        }  
    }, [inputData])

    useEffect(() => {
        if (inputData["belgium_resident"] === 1) {
            action()
        }
        
        if (inputData["belgium_resident"] === 0) {
            if (window.PageBus) {
                window.PageBus.publish("analyticsServices", {
                    eventType: "button click",
                    eventName: "domicile not in BE",
                    trackMethod: "trackAction"
             }
            );
            }
            _step_service({step_ID, setIsLoading, next_step:'end-flow'})
            endFlow() //end-flow
        } 
    }, [nextTick])

    useEffect(() => {
        const asyncfunc = async () => {
            const mobileOptin = (await getStep('optin_mobile')).fieldValue === "1"
            if (window.PageBus) {
                window.PageBus.publish("analyticsServices", {
                pageID: "onboarding",
                stepSeq: "1",
                stepName: "personal info:domicile",
                flowType: "sales",
                flowName: "onboarding",
                productName: "onboarding",
                visualisationType: mobileOptin ? "sms communication authorised" : "sms communication unauthorised",
                trackMethod: "flow"
             }
            );
            }
            const serverData = await getStep(['belgium_resident'])
            setSavedData({belgium_resident: Number(serverData.belgium_resident)})
        }
        asyncfunc()
        
    }, [])

    return (
        <>
            <StepsLoader loading={isLoading}>
                <BaseParagraph>
                    <h3>{t('personal_infos.Personal_info_domicile.title')}</h3>
                </BaseParagraph>

                <InputField type={"select"} name={"belgium_resident"}
                            options={[
                                {value:1, label:t('general.yes')},
                                {value:0, label:t('general.no')}
                                ]}
                    getInputValue={getInputValue}
                    defaultSelect={savedData && savedData[step_ID]}
                />
            </StepsLoader>
        </>
    )
}

BelgianResidenceStep.propTypes = {
    step_ID: PropTypes.string,
    step_URL: PropTypes.string,
    next_step: PropTypes.string,
    setDataToContext: PropTypes.any,
    getDataFromContext: PropTypes.any,
    step_form: PropTypes.array,
    error: PropTypes.array,
    _step_service: PropTypes.func,
}




export default BelgianResidenceStep